import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const calendarSlice = createSlice({
  name: "calendar",
  initialState: {
    scheduledClasses: [],
    atualDate: "",
    activeScreen: "list",
    selectedDateTime: "",
    selectedStart: moment(new Date()),
    selectedEnd: "",
    selectedLingoLanguageId: "",
    selectedType: "",
    selectedPlanId: "",
    selectedStatus: "",
    selectedStudent: "",
    selectedTeacher: "",
  },
  reducers: {
    setScheduledClasses(state, { payload }) {
      const { scheduledClasses } = payload;
      return { ...state, scheduledClasses };
    },
    setCalendarScreen(state, { payload }) {
      const { activeScreen, selectedDateTime } = payload;
      return { ...state, activeScreen, selectedDateTime };
    },
    setCalendarFilters(state, { payload }) {
      const {
        selectedDateTime,
        selectedStart,
        selectedEnd,
        selectedLingoLanguageId,
        selectedType,
        selectedPlanId,
        selectedStatus,
        selectedStudent,
        selectedTeacher,
      } = payload;
      const filters = {
        selectedDateTime,
        selectedStart,
        selectedEnd,
        selectedLingoLanguageId,
        selectedType,
        selectedPlanId,
        selectedStatus,
        selectedStudent,
        selectedTeacher,
      };
      return { ...state, ...filters };
    },
    setCalendarInitialParams(state, { payload }) {
      const {
        activeScreen,
        atualDate,
        selectedDateTime,
        selectedStart,
        selectedEnd,
        selectedLingoLanguageId,
        selectedType,
        selectedPlanId,
        selectedStatus,
        selectedStudent,
        selectedTeacher,
      } = payload;
      const filters = {
        selectedDateTime,
        selectedStart,
        selectedEnd,
        selectedLingoLanguageId,
        selectedType,
        selectedPlanId,
        selectedStatus,
        selectedStudent,
        selectedTeacher,
      };
      return { ...state, ...filters, activeScreen, atualDate };
    },
  },
});

export const { setScheduledClasses, setCalendarScreen, setCalendarFilters, setCalendarInitialParams } =
  calendarSlice.actions;

export default calendarSlice.reducer;
